module.exports = __webpack_public_path__ + "img/icon-handmade.e506e305.svg";